import { useAppSelector } from '@/store/hooks'

const MINIMUM_AGE = 18

const calculateAge = (birthDateTimestamp?: number | null): number | null => {
  if (birthDateTimestamp == null) return null

  const birthDate = new Date(birthDateTimestamp)
  if (Number.isNaN(birthDate.getTime())) return null

  const today = new Date()
  if (birthDate > today) return null

  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }

  return age
}

const useIsAdult = () => {
  const userData = useAppSelector((state) => state.usuario.data)

  const age = calculateAge(userData?.birthDate)
  const isAdult = age === null ? null : age >= MINIMUM_AGE

  // Debug log for development/emulator - shows bridge data
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV === 'development' && userData) {
    const birthDate =
      userData.birthDate !== null && userData.birthDate !== undefined
        ? new Date(userData.birthDate)
        : null
    console.log('🔍 [Age Verification Debug]', {
      birthDate: birthDate?.toLocaleDateString('pt-BR'),
      birthDateTimestamp: userData.birthDate,
      calculatedAge: age,
      isAdult,
      userData: {
        name: userData.name,
        cpf: userData.cpf,
        email: userData.email,
      },
    })
  }

  return {
    isAdult,
    age,
    isLoading: !userData,
  }
}

export default useIsAdult
